export default {
  booking_confirmation_title: 'Rezervasyon onayı',
  booking_confirmation_body: 'Rezervasyonunuz için teşekkürler. Onay bilgilerini aşağıda bulabilirsiniz.',
  location: 'Konum',
  pickup_location: 'Teslim Alma Konumu',
  dropoff_location: 'Teslim Etme konumu',
  vehicle: 'Araç',
  pickup_and_dropoff: 'Teslim Alma ve Teslim Etme (yerel saat)',
  distance_allowance: 'İzin Verilen Mesafe',
  view_voucher: 'Kuponu Görüntüle',
  view_more_bookings: 'Daha Fazla Rezervasyon Görüntüle',
  identity_verification_body: 'Aracı almadan önce kimliğinizi doğrulamanız gerekecek',
  identity_verification_title: 'Kimliği Doğrula',
  search_again: 'Tekrar ara',
  aircon: 'klima',
  refrigeration: 'Buzdolabında',
  not_available: 'Drive &amp; Go, şu anda sadece kimlik ve ehliyeti {profiles} tarafından düzenlenmiş kişilere açıktır; ancak zamanla daha fazla ülke ekleyeceğiz.',
  check_if_included: 'Ülkenizin dahil olup olmadığını kontrol edin.',
  included_in_booking: 'Bu rezervasyonun kapsamı',
  cdw_with_excess: 'Ek ödeme ile hasar muafiyet sigortası',
  theft_protection: 'Ek ödeme ile hırsızlık sigortası',
  risk_reduction: 'Risk azaltma',
  free_extras: 'Bu rezervasyon ile iki ücretsiz ekstra <br /> hakkınız olacak.',
  total_cost: 'Toplam kiralama maliyeti',
  continue: 'Devam et',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'büyük',
  luggage_medium_long_label: 'orta',
  luggage_small_long_label: 'küçük',
  fuel_unspecified_label: 'belirtilmemiş',
  transmission_manual_label: 'Manuel',
  transmission_automatic_label: 'Otomatik',
  make_a_booking: 'Bir rezervasyon yap',
  pickup_date: 'Alma tarihi',
  dropoff_date: 'Teslim tarihi',
  driver_age: 'Sürücü 30-65 yaşları arasında',
  enter_driver_age: 'Lütfen sürücünün yaşını girin',
  promo_code: 'Promosyon Kodu',
  search: 'Ara',
  dropoff_date_cannot_be_before_pickup_date: 'Teslim alma tarihi, teslim etme tarihinden önce olamaz',
  pickup_date_cannot_be_in_the_past: 'Teslim alma tarihi geçmiş bir tarih olamaz',
  pickup_time_cannot_be_in_the_past: 'Teslim alma saati geçmiş bir tarih olamaz',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Teslim alma ve teslim etme aynı gündeyse, teslim etme saati teslim alma saatinden sonraki bir saat olmalıdır',
  vehicle_filters: 'Araç filtreleri',
  reset: 'Sıfırla',
  transmission: 'Vites',
  all: 'Tümü',
  manual: 'Manuel',
  auto: 'Otomatik',
  passengers: 'Yolcular',
  vehicle_type: 'Araç türü',
  filter: 'Filtrele',
  vehicle_search: 'Araç araması',
  edit: 'Düzenle',
  no_results: 'Filtreleme ölçütlerinizle eşleşen bir sonuç bulunamadı.',
  small_cars: 'Küçük arabalar',
  medium_cars: 'Orta boyutlu arabalar',
  large_cars: 'Büyük arabalar',
  estate_cars: 'Steyşın',
  suvs: 'SUV\'ler',
  mpvs: 'MPV\'ler',
  vans: 'Minibüs',
  camper_vans: 'Karavan',
  premium: 'Premium',
  unspecified: 'belirtilmemiş',
  large: 'büyük',
  medium: 'orta',
  small: 'küçük',
  automatic: 'otomatik',
  you_have_been_refunded: 'İadeniz gerçekleştirildi.',
  please_customer_service: 'Bir rezervasyon yapmak için lütfen müşteri hizmetlerimizle iletişime geçin.',
  contact_customer_service: 'Müşteri hizmetleriyle iletişime geç',
  booking_failed: 'Rezervasyon işleminiz şu anda gerçekleştirilemiyor.',
  summary: 'Özet',
  reforestation_and_protection: 'Kosta Rika genelinde yeniden ağaçlandırmayı ve orman yağmurlarının korunmasını destekleyin',
  cost_of_rental: 'Kiralama maliyeti',
  to_pay_now: 'Şimdi ödenecek',
  pay_on_arrival: 'Geldiğinizde ödenecek',
  greenheart_donation: 'Yeşil kalp bağışı',
  tc_agreement: '{0} okudum ve anladım.',
  tc: 'şartlar ve koşullar',
  receive_offers: 'Özel tekliflerden e-posta ile haberdar olmak istiyorum.',
  donate: 'Evet, {amount} tutarında bağış yapmak istiyorum.',
  pay_now: '{amount} tutarını şimdi öde',
  driver_details: 'Sürücü bilgileri',
  complete_driver_details: 'Lütfen sürücü bilgilerini tamamlayın.',
  are_you_the_driver: 'Sürücü siz misiniz?',
  have_an_account: 'Halihazırda bir hesabınız var mı?',
  login: 'Oturum aç',
  or: 'veya',
  first_name: 'Sürücünün Adı',
  last_name: 'Sürücünün Soyadı',
  email: 'E-posta adresi',
  phone_number: 'Cep telefonu numarası',
  unable_to_save_driver_information: 'Sürücü bilgileri kaydedilemedi. Lütfen tekrar deneyin.',
  pay_on_arrival: 'Geldiğinizde ödeyin',
  pay_online_now: 'Şimdi çevrimiçi ödeyin',
  day: 'Gün',
  choose_location: 'Bir konum seçin',
  pickup_location: 'Teslim alma konumu',
  dropoff_location: 'Teslim etme Konumu',
  location_not_found: 'Üzgünüz, talep ettiğiniz konumu bulamadık.',
  add: 'Ekle',
  remove: 'Kaldır',
  free_extra: 'Ücretsiz ekstra',
  free: 'ÜCRETSİZ!',
  fast_track_notice: 'Bu hizmet için belge düzenleyicisine yönelik kısıtlamalar uygulanmaktadır. Yalnızca şu ülke tarafından düzenlenen belgelere sahip kişilere açıktır:',
  complete_booking: 'Rezervasyonu Tamamla',
  choose_card: 'Lütfen bir kart seçin veya yeni bir kart ekleyin.',
  add_billing_details: 'Lütfen fatura bilgilerini ekleyin.',
  card_number: 'Kart numarası',
  card_holder_name: 'Kart sahibinin adı',
  card_exp: 'AA / YY',
  card_cvc: 'CVC',
  save_card: 'Kart kaydedilsin mi?',
  amount_charged: 'Kartınızdan şu tutar çekilecek:',
  payment_confirmation: 'Rezervasyonu onayla ve öde',
  payment_methods: 'mevcut ödeme yöntemleri',
  use_saved_card: 'x kayıtlı kartı kullan',
  use_different_card: '+ farklı bir kart kullan',
  book_now: 'Şimdi rezervasyon yap',
  minimum_age: 'Yalnızca {age} Yaş Üstü',
  excess_liability: 'Sorumluluk muafiyeti',
  security_deposit: 'Deposito',
  fuel_policy: 'Yakıt Politikası',
  like_for_like: 'Aldığın Gibi Bırak',
  full_to_full: 'Dolu Teslim Al, Dolu Teslim Et',
  miles_per_rental: 'Adil yakıt politikası {mileage} mil',
  km_per_rental: 'Adil yakıt politikası {mileage} km',
  unlimited: 'Sınırsız',
  unlimited_mileage: 'Sınırsız mil',
  unlimited_mileage_km: 'Sınırsız km',
  non_amendable: 'Değiştirilemez',
  non_refundable: 'İade Yok',
  free_cancellation_until: 'Şu tarihe kadar ücretsiz iptal:',
  cancellation_in_line_with: 'İptal işlemleri',
  tcs: 'Şart ve Koşullar doğrultusundadır',
  free_extras_on_collection: 'Alım noktasında iki ücretsiz ekstra',
  glass_and_tyres_covered: 'Cam ve lastik güvenceli',
  number_of_passengers: 'Yolcu sayısı',
  number_of_bags: 'Çanta sayısı',
  fuel_type: 'Yakıt türü',
  co2: 'Karbondioksit',
  aircon: 'Klima',
  book_type: '{type} rezervasyonu yap',
  processing: 'İşlem gerçekleştiriliyor',
  actual_price: 'Gerçek fiyat',
  tooltip: '{currencyCode} cinsinden tutar, döviz kuruna dayalı tahmini bir tutardır; {currency} cinsinden tutar bağlayıcıdır.',
  deposit: 'Depozit',
  pay_online: 'Şimdi çevrimiçi ödeyin',
  pay_online_without_extras: 'Kiralama ücreti',
  extras_on_arrival: 'Ekstralar geldiğinizde eklenecek',
  insurance_on_arrival: 'Risk azaltma - Geldiğinizde ödeyin',
  insurance_online: 'Risk azaltma - Şimdi öde',
  extras_online: 'Ekstraları şimdi öde',
  green_heart_donation: 'Yeşil Kalp Bağışı',
  aircon_lower: 'klima',
  why_use_drive_and_go: 'Neden Drive & Go\'yu Kullanmalıyım?',
  straight_to_car: 'Doğrudan arabaya gidin',
  no_queues: 'Kuyrukta beklemeyin',
  self_checkout: 'Çıkışınızı kendiniz yapın',
  cant_lose_key: 'Anahtarı kaybetmek yok',
  online_id_check: 'Çevrimiçi kimlik kontrolü',
  phone_as_key: 'Anahtar yerine telefon',
  premiumplus_benefits_includes: 'Premium Plus+ avantajları da dahildir',
  book_drive_go: 'Drive & Go Rezervasyonu Yap',
  duration: 'Süre',
  to_pay_on_arrival: 'Geldiğinizde ödenecek',
  return_date: 'İade Tarihi',
  my_profile: null,
  additional_options: 'Ek Seçenekler',
  booking_details: 'Rezervasyon Bilgileri',
  price_for_x_days: '{qty_of_days} günlük ücret | {qty_of_days} günlük ücret',
  cancelled: 'İptal Edildi',
  upcoming: 'Yaklaşan',
  active: 'Aktif',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go, şu anda şu ülkeler tarafından verilmiş kimlik ve ehliyet sahibi kişilerin kullanımına açıktır:',
    drive_and_go_today: 'Bugün Drive & Go rezervasyonu!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Neden Drive & Go\'yu Kullanmalıyım?',
    straight_to_car: 'Doğrudan arabaya gidin',
    no_queues: 'Kuyrukta beklemeyin',
    self_checkout: 'Çıkışınızı kendiniz yapın',
    cannot_lose_the_key: 'Anahtarı kaybetmek yok',
    online_id_check: 'Çevrimiçi kimlik kontrolü',
    phone_as_a_key: 'Anahtar yerine telefon',
    premium_plus_benefits_also_included: 'Premium Plus+ avantajları da dahildir',
    book_drive_and_go: 'Drive & Go Rezervasyonu Yap'
  },
  my_bookings: "My booking",
  no_bookings: "No booking",
  no_bookings_to_display: 'Görüntülenecek rezervasyon yok.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Teslim alımdaki kilometre sayacı',
  fuel_at_collection: 'Teslim alımdaki yakıt',
  start_check_in: 'Giriş kaydını başlat',
  start_collection: 'Teslim alımı başlat',
  recent_bookings: 'Geçmiş rezervasyonlar',
  damage: {
    updated_damage_report_submitted: 'Güncellenmiş hasar raporu gönderildi. Gerektiğinde müşteri hizmetleri ekibinden bir görevli iletişime geçecektir.',
    add_additional_damage: 'Ek hasar ekle',
    you_may_report_additional_damage_up_to: 'Araç çıkış kaydı yapıldıktan sonra, 24 saate kadar ek hasar bildiriminde bulunabilirsiniz.',
    specify_damage: 'Hasar belirtin',
    please_choose_the_area_and_type_of_damage: 'Lütfen hasar bölgesini ve türünü seçin',
    type_of_damage: 'Hasar türü',
    is_this_more_than_5_cm: 'Hasar 5 cm\'den büyük mü?',
    please_take_or_select_a_photo: 'Lütfen bir fotoğraf çekin veya seçin',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Lütfen hasarın net bir şekilde görünür olduğu bir fotoğraf çekin',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Gerekirse yeni fotoğraf ekleme simgesini seçerek başka bir fotoğraf ekleyebilirsiniz',
    save_image: 'Görüntüyü Kaydet',
    save_images: 'Görüntüleri Kaydet',
    damage_saved_successfully: 'Hasar başarıyla kaydedildi',
    add_photo: 'Fotoğraf ekle'
  },
  checkout: {
    start_collection: 'Teslim Alımı Başlat',
    collect_vehicle: 'Aracı Teslim Al',
    we_will_let_you_know_the_details: 'Kiralık aracın yerini bulmanız için konumu ve bilgileri sizinle paylaşacağız.',
    inspect: 'Kontrol',
    we_will_ask_for_four_photos_from_each_corner: 'Aracın, varsa henüz listelenmemiş hasarlarla birlikte her köşesinden çekilmiş dört fotoğrafını isteyeceğiz.',
    fuel_and_milage: 'Yakıt ve Kilometre',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Kiralama sürecinizin başında, kilometre sayacı ve yakıt bilgilerini onaylarsınız.',
    sign: 'İmzala',
    sign_the_rental_agreement: 'Kiralama sözleşmesini imzalayın.',
    away_you_go: 'Artık gidebilirsiniz',
    you_are_free_to_take_to_the_road: 'Yola çıkmaya hazırsınız!',
    collect_your_vehicle: 'Aracınızı teslim alın',
    get_directions: 'Yön Bilgilerini Al',
    hide_directions: 'Yön Bilgilerini Gizle',
    local_time: 'yerel saat',
    tel: 'Tel',
    getting_to_the_location: 'Konuma gitmek',
    get_vehicle_details: 'Araç bilgilerini al',
    view_map: 'Haritayı Görüntüle',
    unlock_vehicle_and_continue: 'Araç kilidini aç ve devam et',
    unable_to_connect_to_vehicle: 'Araca bağlanılamıyor',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Araca bağlanamadık; lütfen doğru aracın yanında olduğunuzdan emin olun ve tekrar deneyin.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Araç rezervasyonunu bulamadık. Lütfen daha sonra tekrar deneyin.',
    odometer_and_fuel: 'Kilometre sayacı ve yakıt',
    odometer: 'Kilometre sayacı',
    please_confirm_the_odometer_and_fuel_readings: 'Lütfen kilometre sayacı ve yakıt bilgilerini onaylayın.',
    the_odometer_field_is_required: 'Kilometre sayacı alanı zorunludur',
    and_must_be_greater_than_the_checkout_odometer: 've çıkış kaydındaki kilometre değerinden büyük olmalıdır',
    confirm: 'Onayla',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Lütfen aracın her köşesinden bir fotoğrafını çekin',
    pre_existing_damage: 'Önceden Mevcut Olan Hasar',
    no_pre_existing_damage: 'Önceden mevcut olan hasar yok.',
    new_damage: 'Yeni Hasar',
    add_additional_damage: 'ek hasar ekle',
    no_new_damage_to_report: 'Bildirilecek yeni hasar yok',
    checkout_complete: 'Çıkış kaydı tamamlandı',
    start_rental: 'Kiralamayı başlat',
    congratulations_name_it_is_time_to_take_to_the_road: 'Tebrikler {customer_name}, yola çıkmaya hazırsınız!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Araç çıkış kaydınızı tamamlayamadık.',
    please_do_the_following: 'Lütfen aşağıdaki işlemleri gerçekleştirin',
    remove_all_belonging_and_lock_the_vehicle: 'Tüm eşyalarınızı çıkarın ve aracı kilitleyin.',
    lock_vehicle: 'Aracı Kilitle',
    once_you_have_contacted_customer_services: 'Müşteri hizmetleriyle iletişime geçtikten sonra',
    vehicle_location: 'Araç Konumu',
    collect_your: 'Teslim Alın:',
    from: 'Şuradan:',
    key_in_glove_box: 'anahtarınız torpido gözünde bulunur',

    keyholder: {
      not_detected: 'Anahtar tutucuda anahtar algılanmadı',
      not_detected_please_try_again: 'Lütfen anahtarınızı anahtar tutucuya yerleştirin ve tekrar deneyin.',

      not_installed: 'Anahtar tutucu yüklü değil',
      not_installed_please_contact_customer_service: 'Anahtar tutucu kurulu değil, lütfen müşteri hizmetlerine başvurun.',
    },
    keyring: {
      look_up_failed: 'Anahtarlık araması başarısız oldu',
      look_up_failed_please_contact_customer_service: 'Anahtarlık arama yanlış, lütfen müşteri hizmetlerine başvurun.',
    },
    key: {
      invalid: 'Anahtar geçersiz',
      invalid_please_contact_customer_service: 'Anahtarınız geçersiz, lütfen müşteri hizmetlerine başvurun.',

      expired: 'Anahtarın süresi doldu',
      expired__please_contact_customer_service: 'Anahtarınızın süresi doldu, lütfen müşteri hizmetlerine başvurun.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Aracı nereye park ettiğinizi bize bildirin.',
    fuel_and_milage: 'Yakıt ve Kilometre',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Kiralama sürecinizin sonunda, kilometre sayacı ve yakıt bilgilerini onaylarsınız.',
    inspect: 'Kontrol',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Aracın, varsa kiralama esnasında meydana gelmiş yeni hasarlarla birlikte her köşesinden çekilmiş dört fotoğrafını isteyeceğiz.',
    lock: 'Kilitle',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Hiçbir eşya unutmadığınızdan emin olun ve aracı kilitleyin.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Lütfen aracı nereye park ettiğinizi bize bildirin.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Araç kilitlendikten sonra, kilidini tekrar açmak mümkün olmayacaktır.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, lütfen eşya bırakmadığınızı kontrol edin, aracı kilitleyin ve gerekiyorsa fiziksel anahtarı anahtarlığa geri gönderin.',
    lock_vehicle: 'Aracı Kilitle',
    complete_check_in: 'Giriş Kaydını Tamamla',
    inspection: 'Kontrol',
    complete_vehicle_check_in: 'Araç giriş kaydını tamamlayın',
    we_are_unable_to_complete_your_vehicle_check_in: 'Araç giriş kaydınızı tamamlayamadık.',
    please_contact_customer_services: 'Lütfen müşteri hizmetleriyle iletişime geçin.',
    once_you_have_contacted_customer_services: 'Müşteri hizmetleriyle iletişime geçtikten sonra'
  },
  rental_agreement: {
    rental_agreement: 'Kiralama sözleşmesi',
    agreement_between: 'Sözleşmenin Tarafları',
    and: 've',
    sign_rental_agreement: 'Kiralama sözleşmesini imzala',
    i_have_read_and_understood_the_terms_and_conditions: 'şartlar ve koşullar ı okudum ve anladım ve aracın durumunu kabul ettim'
  },
  full_insurance_no_deposit: 'Fuld forsikring & ingen depositum kræves',
  excess: '{amount} overskydende',
  deposit: '{amount} indbetaling',
  included_daily_distance: '{distance} {unit} pr. dag',
  miles: 'miles',
  kilometers: 'kilometer',
  collection_details_title: 'Koleksiyon Ayrıntıları',
  collection_details_not_found: 'Bu konum için koleksiyon ayrıntısı tanımlanmadı',
  free_cancellation: 'Ücretsiz iptal',
  no_deposit: 'No Deposit',
  benefit_from: 'Gönderen Fayda',
  for_only_per_day: 'günde sadece {price} İçin',
  upgrade_mee: 'UpgradeMee'
}
